import React from "react";
import Chart from "react-apexcharts";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import { connect } from "react-redux";
import { CalendarIcon, DocumentsIcon, DownloadIcon, TimeIcon, UploadIcon } from "../../assets/Icons";

class DashboardChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: `Total Users`,
          data: [],
        },
        {
          name: `Active Users`,
          data: [],
        },
        {
          name: `New Users`,
          data: [],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454", "#2f3a79"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Overview",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "No. of users",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },

      //   2

      series2: [
        {
          name: "Calls made",
          data: [],
        },
      ],
      options2: {
        chart: {
          height: 350,
          type: "bar",
        },
        colors: ["#2F3A79"],
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val * 1;
          },
          offsetY: -30,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },

        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              },
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val * 1;
            },
          },
        },
        title: {
          text: "Month",
          floating: true,
          offsetY: 350,
          align: "center",
          style: {
            color: "#444",
          },
        },
      },

      // 3

      seriesCallRatio: [0, 0],
      optionsCallRatio: {
        chart: {
          width: 380,
          type: "pie",
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value + "%";
            },
          },
        },
        labels: ["Sucessful Calls", "Unsucessful Calls"],
        colors: ["#2f3a79", "#525252"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      // 5

      totalWorkflow: [0],
      options5: {
        chart: {
          height: 350,
          type: "radialBar",
          toolbar: {
            show: true,
          },
        },
        colors: ["#2F3A79"],
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: "70%",
              background: "#fff",
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: "front",
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24,
              },
            },
            track: {
              background: "#fff",
              strokeWidth: "67%",
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35,
              },
            },

            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: "#888",
                fontSize: "17px",
              },
              value: {
                formatter: function (val) {
                  return parseInt(val);
                },
                color: "#111",
                fontSize: "36px",
                show: true,
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: [""],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: ["Total"],
      },

      // 7
      series_workflow_performend: [
        {
          data: [],
        },
      ],
      options_workflow_performend: {
        chart: {
          type: "bar",
          height: 350,
        },
        colors: ["#2F3A79"],
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
        },
      },

      // 8

      WorkflowAnalyticsSeries: [
        {
          name: "Total Workflow",
          data: [28, 29, 33, 36, 32, 32, 33],
        },
        {
          name: "Total Users",
          data: [12, 11, 14, 18, 17, 13, 13],
        },
      ],
      WorkflowAnalyticsOption: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454", "#2f3a79"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Workflow Analytics",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "No. of Users",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },

      // 9

      series9: [
        {
          name: "Weekly Uploads",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Weekly Downloads",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      options9: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#77B6EA", "#545454"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Weekly Uploads and Downloads",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "No. of Users",
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },

      // Now Updated Work
      Years: [],
      userChartInfo: [],
      loadCharts: false,
      userRating: [],
      performedWorkflow: [],
      temp_rating: [],

      series10: [],
      options10: {}

    };
  }

  componentDidMount() {
    let i,
      Years = [];
    for (i = 2020; i <= new Date().getFullYear(); i++) {
      Years.push(i);
    }
    this.setState({ Years: Years, loadCharts: true });
    this.getUserDataOrgOverview(new Date().getFullYear());
    this.getUsersRating();
    this.getCallSuccessRatio();
    this.getsAdminWorkflowPerformed();
    this.getsAdminCallingData(new Date().getFullYear());
    this.getsAdminWorkflowAnalysis(new Date().getFullYear());
  }
  getsAdminCallingData = (year) => {
    var data = {
      s_id: ud.main_id,
      year: year,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminCallingData`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            let month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let temp_arr = [];
            month.map((list, index) => {
              let obj = response.data.data.find((raw) => raw.month == list);
              if (obj) {
                temp_arr.push(obj.total);
              } else {
                temp_arr.push(0);
              }
            });

            _this.setState({
              series2: [
                {
                  name: "Calls made",
                  data: temp_arr,
                },
              ],
            });
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getsAdminCallingData(year);
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  getsAdminWorkflowAnalysis = (year) => {
    var data = {
      s_id: ud.main_id,
      year: year,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminWorkflowAnalysis`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            let month = [
              { month: "Jan", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Feb", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Mar", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Apr", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "May", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Jun", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Jul", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Aug", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Sep", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Oct", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Nov", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
              { month: "Dec", workflow_id: [], user_id: [], total_workflow_count: 0, total_user_count: 0 },
            ];
            let total_workflow_arr = [];
            let total_user_arr = [];
            let total_no_workflow = [];

            month.map((list, index) => {
              let res_obj = response.data.data.filter((raw) => raw.month == list.month);
              if (res_obj.length > 0) {
                res_obj.map((li, ind) => {
                  let check_user_id_cache = list.workflow_id.find((raw) => raw == li.workflow_id);
                  let check_user = list.user_id.find((raw) => raw == li.user_id);
                  if (check_user == undefined) {
                    list.user_id.push(li.user_id);
                  }
                  if (check_user_id_cache) {
                    list.total_workflow_count += li.total_workflow;
                  } else {
                    list.workflow_id.push(li.workflow_id);
                    list.total_workflow_count += li.total_workflow;
                  }
                  if (res_obj.length - 1 == ind) {
                    total_workflow_arr.push(list.total_workflow_count);
                    total_user_arr.push(list.user_id.length);
                    total_no_workflow.push(list.workflow_id.length);
                  }
                });
              } else {
                total_workflow_arr.push(0);
                total_user_arr.push(0);
                total_no_workflow.push(0);
              }

              if (index == 11) {
                _this.setState({
                  WorkflowAnalyticsSeries: [
                    {
                      name: "Total Workflow Performed",
                      data: total_workflow_arr,
                    },
                    {
                      name: "Total Users",
                      data: total_user_arr,
                    },
                    {
                      name: "Total Workflow",
                      data: total_no_workflow,
                    },
                  ],
                });
              }
            });
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getsAdminWorkflowAnalysis(year);
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  getUsersRating = () => {
    var data = {
      s_id: ud.main_id,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminUsersRating`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            _this.setState({ userRating: response.data.data, temp_rating: response.data.data });
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getUsersRating();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  getCallSuccessRatio = () => {
    var data = {
      s_id: ud.main_id,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminCallingSuccessRatio`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            if (response.data.data.length == 1) {
              _this.setState({
                seriesCallRatio: [
                  Number(response.data.data[0].success_percentage),
                  Number(response.data.data[0].unsuccess_percentage)
                ],
              });
            } else {
              _this.setState({ seriesCallRatio: [0, 0] });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getCallSuccessRatio();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  getsAdminWorkflowPerformed = () => {
    var data = {
      s_id: ud.main_id,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminWorkflowPerformed`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            let Workflow_name = [];
            let Workflow_count = [];
            response.data.data.map((list, index) => {
              Workflow_name.push(list.title);
              Workflow_count.push(list.total_performed);
            });

            _this.setState({
              series_workflow_performend: [
                {
                  name: "Total Count ",
                  data: Workflow_count,
                },
              ],
              options_workflow_performend: {
                chart: {
                  type: "bar",
                  height: 350,
                },
                plotOptions: {
                  bar: {
                    horizontal: true,
                  },
                },
                dataLabels: {
                  enabled: false,
                },
                xaxis: {
                  categories: Workflow_name,
                },
              },
            });

            return;
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getsAdminWorkflowPerformed();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  getUserDataOrgOverview = (year) => {
    var data = {
      s_id: ud.main_id,
      year: year,
      groupId: this.props?.groupId,
      unoToken: this.props?.user?.userDetails?.token,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/sAdminUsersData`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error == false) {
            let mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let NewUser = [];
            let TotalUser = [];
            let ActiveUser = [];
            let Default_val =
              response.data.total_and_new_user.length > 0 ? response.data.total_and_new_user[0].total_old : 0;
            mon.map((list, index) => {
              let findobj = response.data.total_and_new_user.find((raw) => raw.month == list);
              if (findobj) {
                Default_val = findobj.totalPerMonth + Default_val;
                NewUser.push(findobj.totalPerMonth);
                TotalUser.push(Default_val);

                ActiveUser.push(response.data.active_users.filter((raw) => raw.month == index + 1).length);
              } else {
                NewUser.push(0);
                ActiveUser.push(0);
                TotalUser.push(Default_val);
              }
            });

            _this.setState({
              series: [
                {
                  name: `Total Users`,
                  data: TotalUser,
                },
                {
                  name: `Active Users`,
                  data: ActiveUser,
                },
                {
                  name: `New Users`,
                  data: NewUser,
                },
              ],

              loadCharts: true,
            });
            return;
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.getUserDataOrgOverview(year);
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  onChangeInputDropDown = (e) => {
    this.getUserDataOrgOverview(Number(e.target.value));
    this.getsAdminCallingData(Number(e.target.value));
    this.getsAdminWorkflowAnalysis(Number(e.target.value));
    this.setState({
      loadCharts: false,
    });
  };
  onChangeInputDropDownFilter = (e) => {
    if (e.target.value == 0) {
      this.setState({
        userRating: this.state.temp_rating,
      });
      return;
    }
    this.setState({
      userRating: this.state.temp_rating.filter((raw) => raw.usertype == e.target.value),
    });
  };
  componentWillReceiveProps(props) {
    let _totalWorkflows = Number(props.no_Workflow);
    let _totalLiveWorkflows = Number(props.totaLiveWorkflows);
    let inactive_Workflow = _totalWorkflows - _totalLiveWorkflows;

    this.setState({
      totalWorkflow: _totalWorkflows,
      series10: [_totalLiveWorkflows, inactive_Workflow]
    });

    this.setState({
      options10: {
        chart: {
          type: "donut",
        },
        labels: ["Active", "Inactive"],
        legend: {
          position: "bottom",
        },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            // show actual numbers instead of percentage
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                },
                value: {
                  show: true,
                },
                total: {
                  show: true,
                  label: "Total",
                  fontSize: "18px",
                  fontWeight: 600,
                  formatter: () => props.no_Workflow,
                },
              },
            },
          },
        },
      }

    });

  }
  render() {
    const { loading } = this.props;
    return (
      <div className="sitechart">
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
              <div className="card-header border-radius-top-15">
                <h4 className="d-flex align-items-center">
                  {" "}
                  <CalendarIcon /> <span className="ml-2">Select Year</span>{" "}
                </h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-2 mb-4">
                    <select name="sop" className="form-control" onChange={this.onChangeInputDropDown}>
                      {this.state.Years.map((list, index) => (
                        <option selected={list == new Date().getFullYear() ? true : false} value={list}>
                          {list}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card document_gradient_border padding-0">
                      <div className="card-header border-radius-top-15">
                        <h5>Organization Overview </h5>
                      </div>
                      <div className="card-body">
                        <div id="chart">
                          {loading ? (
                            <div className="skeleton" style={{ height: "350px", width: "100%" }} />
                          ) : (
                            <Chart options={this.state.options} series={this.state.series} type="line" height={350} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card document_gradient_border padding-0 mt-4">
                      <div className="card-header border-radius-top-15">
                        <h5>Calls Data</h5>
                      </div>
                      <div className="card-body">
                        <div id="chart">
                          <Chart options={this.state.options2} series={this.state.series2} type="bar" height={350} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

         {/* <div className="row mt-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
              <div className="card-body">
                <div className="row mt-4">
                 <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card document_gradient_border padding-0  border-before-15">
                      <div className="card-header">
                        <h4>User Ratings</h4>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-striped table-bordered table-hover">
                            <thead>
                              <tr>
                                <th className="border-top-0">S.No</th>
                                <th className="border-top-0">User Name </th>
                                <th className="border-top-0">Email ID </th>
                                <th className="border-top-0" style={{ width: "250px" }}>
                                  <div className="d-flex">
                                    User Type
                                  </div>
                                </th>
                                <th className="border-top-0">Rating</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.userRating.map((list, index) => (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>{list.name}</td>
                                  <td>{list.email}</td>
                                  <td>{list.usertype == 1 ? "SME" : "FO"}</td>
                                  <td>
                                    {list.final_rating.toFixed(1)}
                                    <i className="mdi mdi-star text-warning"></i>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card mt-3 document_gradient_border padding-0  border-before-15">
                      <div className="card-header">
                        <h4>Call Success Ratio</h4>
                      </div>
                      <div className="card-body">
                        <div id="chart">
                          <Chart
                            options={this.state.optionsCallRatio}
                            series={this.state.seriesCallRatio}
                            type="pie"
                            height={350}
                          />
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>*/}

        <div className="row mt-4">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
              <div className="card-header border-radius-top-15">
                <h4>Workflow And Call Success Ratio Dashboard</h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 h-100">
                    <div className="card document_gradient_border padding-0  border-before-15 h-100">
                      <div className="card-body">
                        <h5>My Workflow's</h5>

                        <div id="chart">
                          {/* <Chart
                            options={this.state.options5}
                            series={this.state.totalWorkflow}
                            type="radialBar"
                            height={400}
                          /> */}
                          <Chart
                            options={this.state.options10}
                            series={this.state.series10}
                            type="donut"
                            height={400}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 h-100">
                    <div className="card document_gradient_border padding-0  border-before-15 h-100">
                      <div className="card-header">
                        <h4>Call Success Ratio</h4>
                      </div>
                      <div className="card-body">
                        <div id="chart">
                          <Chart
                            options={this.state.optionsCallRatio}
                            series={this.state.seriesCallRatio}
                            type="pie"
                            height={350}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="card document_gradient_border padding-0  border-before-15 h-100">
                      <div className="card-body">
                        <h5>Top 5 most performed Workflow's</h5>
                        <div id="chart">
                          <Chart
                            options={this.state.options_workflow_performend}
                            series={this.state.series_workflow_performend}
                            type="bar"
                            height={350}
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
                {/* <div className="row mt-4">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card document_gradient_border padding-0  border-before-15">
                      <div className="card-header">
                        <h4>Workflow Analytics </h4>
                      </div>
                      <div className="card-body">
                        <div id="chart">
                          {this.state.loadCharts ? (
                            <Chart
                              options={this.state.WorkflowAnalyticsOption}
                              series={this.state.WorkflowAnalyticsSeries}
                              type="line"
                              height={350}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row mt-4 documentmanager">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="card">
              <div className="card-header border-radius-top-15">
                <h4>
                  Document Manager Dashboard{" "}
                </h4>
                <p className="text-danger">This chart will be live on next phase.</p>
              </div>
              <div className="card-body">
                <div className="xp-chart-label">
                  <ul className="list-inline">
                    <li className="list-inline-item document_gradient_border">
                      <p className="text-black">Total Documents</p>
                      <h4 className="text-dark">
                        <i>
                          <DocumentsIcon />{" "}
                        </i>
                        0
                      </h4>
                    </li>
                    <li className="list-inline-item document_gradient_border">
                      <p className="text-black">Times Viewed</p>
                      <h4 className="text-dark">
                        <i>
                          <TimeIcon />{" "}
                        </i>
                        0
                      </h4>
                    </li>
                    <li className="list-inline-item document_gradient_border">
                      <p className="text-black">Weekly Downloads</p>
                      <h4 className="text-dark">
                        <i>
                          <DownloadIcon />{" "}
                        </i>
                        0
                      </h4>
                    </li>
                    <li className="list-inline-item document_gradient_border">
                      <p className="text-black">Weekly Uploads</p>
                      <h4 className="text-dark">
                        <i>
                          <UploadIcon />{" "}
                        </i>
                        0
                      </h4>
                    </li>
                  </ul>
                </div>
                <div className="card document_gradient_border padding-0">
                  <div className="card-header border-radius-top-15">
                    <h4>Weekly Analytics</h4>
                  </div>
                  <div className="card-body w-100">
                    <div id="chart" className="w-100">
                      <Chart options={this.state.options9} series={this.state.series9} type="line" height={350} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData,
});

export default connect(mapStateToProps)(DashboardChart);
